import React from 'react';
import Icon from 'components/ui/icon';
import classNames from 'classnames';

import { addTranslation, IntlProps } from 'decorators/addTranslation';
import { addPermissions, WithPermissions } from 'decorators/addPermissions';
import { ModalChartTypes } from 'types/Analytics';
import { connect } from 'react-redux';
import { RootState } from 'store';

export enum AdvancedAnalyticsEntityType {
  operations = 'operations',
  success_rate = 'success_rate',
  inout = 'inout',
  topten = 'topten',
  declineReasons = 'declineReasons',
  fraud_report = 'fraud_report',
  chargeback = 'chargeback',
  vat_analytics = 'vat_analytics',
}

interface ConnectedProps {
  user: {
    isSuccessRateChartAvailable: boolean;
    isShowVatFieldsEnabled: boolean;
  };
}

interface OwnProps {
  setType: (type: AdvancedAnalyticsEntityType) => void;
  selectedType: AdvancedAnalyticsEntityType;
  chartTypes: ModalChartTypes;
}

type Props = OwnProps & ConnectedProps & IntlProps & WithPermissions;

class AdvancedAnalyticsEntityTypes extends React.Component<Props> {
  getContent({ id, icon, text, title }) {
    const { setType, selectedType, getTranslate } = this.props;

    return (
      <div
        key={id}
        className={classNames(`chart-types__item`, {
          'chart-types__item_selected': id === selectedType,
        })}
        onClick={() => setType(id)}>
        <div className='chart-types__title'>
          <div
            className={classNames(
              'chart-types__svg-container',
              icon.className
            )}>
            <Icon name={icon.name} size={16} />
          </div>
          <span>{getTranslate(title)}</span>
        </div>
        <div className='chart-types__description'>{getTranslate(text)}</div>
      </div>
    );
  }

  whatToRender({ id, icon, text, title, permission }) {
    const { isEnabled } = this.props;

    if (permission !== undefined && isEnabled(permission)) {
      return this.getContent({ id, icon, text, title });
    } else if (permission !== undefined && !isEnabled(permission)) {
      return null;
    }
    return this.getContent({ id, icon, text, title });
  }

  render() {
    const { chartTypes, user } = this.props;

    return (
      <div className='chart-types'>
        {chartTypes.map(({ id, title, icon, text, permission }) => {
          if (
            (id === AdvancedAnalyticsEntityType.success_rate &&
            !user.isSuccessRateChartAvailable) ||
            (id === AdvancedAnalyticsEntityType.vat_analytics &&
            !user.isShowVatFieldsEnabled)
          ) {
            return null;
          }

          return this.whatToRender({ id, icon, text, title, permission });
        })}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): ConnectedProps => ({
  user: state.user,
});

const AdvancedAnalyticsEntityTypes_ = connect(mapStateToProps)(
  addTranslation(addPermissions(AdvancedAnalyticsEntityTypes))
);

export { AdvancedAnalyticsEntityTypes_ as AdvancedAnalyticsEntityTypes };
